//  Time-stamp: "2016-07-25 06:23:07 MDT"
module.exports = [
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', 'A', 'B', 'G', 'D', 'E', 'Z', 'E', 'E', "T`", 'Zh', 'I', 'L', 'Kh', 'Ts', 'K',
'H', 'Dz', 'Gh', 'Ch', 'M', 'Y', 'N', 'Sh', 'O', "Ch`", 'P', 'J', 'Rh', 'S', 'V', 'T',
'R', "Ts`", 'W', "P`", "K`", 'O', 'F', '[?]', '[?]', "<", "'", "/", "!", ",", "?", ".",
'[?]', 'a', 'b', 'g', 'd', 'e', 'z', 'e', 'e', "t`", 'zh', 'i', 'l', 'kh', 'ts', 'k',
'h', 'dz', 'gh', 'ch', 'm', 'y', 'n', 'sh', 'o', "ch`", 'p', 'j', 'rh', 's', 'v', 't',
'r', "ts`", 'w', "p`", "k`", 'o', 'f', 'ew', '[?]', ".", "-", '[?]', '[?]', '[?]', '[?]', '[?]',
'[?]', "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
"", "", '[?]', "", "", "", "", "", "", "", "", "", "", "", "", "",
"\\@", 'e', 'a', 'o', 'i', 'e', 'e', 'a', 'a', 'o', '[?]', 'u', "'", "", "", "",
//  u+05c0:
"|", "", "", ":", "", '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',


"", 'b', 'g', 'd', 'h', 'v', 'z', 'kh', 't', 'y', 'k', 'k', 'l', 'm', 'm', 'n',
'n', 's', "`", 'p', 'p', 'ts', 'ts', 'q', 'r', 'sh', 't', '[?]', '[?]', '[?]', '[?]', '[?]',
'V', 'oy', 'i', "'", "\"", '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]', '[?]',
];
